import { render, staticRenderFns } from "./homeMotion.vue?vue&type=template&id=8106bb22&scoped=true&"
import script from "./homeMotion.vue?vue&type=script&lang=js&"
export * from "./homeMotion.vue?vue&type=script&lang=js&"
import style0 from "./homeMotion.vue?vue&type=style&index=0&id=8106bb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8106bb22",
  null
  
)

export default component.exports